module.exports = __webpack_public_path__ + "img/logo.ffaf3f78.png";